import { useI18n } from 'vue-i18n';

export function useStringHelpers() {
    /**
     * Splits the string at the first instance of one of given words.
     * @param value String to split.
     * @param splitAtWords Words to split at.
     */
    function splitAtWord(value?: string | null, words: string[] = ['via', 'mot']): string[] {
        if (!value) return [];
        return value.split(new RegExp(`(\\b(?:${words.join('|')})\\b.*)`, 'i'), 2).map(x => x.trim());
    }

    return {
        splitAtWord
    };
}

export function useUnitsOfMeasure() {
    const { t } = useI18n();

    const unitsOfMeasure = {
        minutes: t('common.resources.minutes', 'min'),
        hours: t('common.resources.hours', 'h')
    };

    return {
        unitsOfMeasure
    };
}
